import { useRouter } from 'next/router'
import React from 'react'
import { Setters } from 'src/features/atoms/glove/japan/Components'
import { SET_FIGURE_PANEL_NUMBER } from 'src/features/atoms/glove/japan/constants/actionType'
import { atomsBaseModel } from 'src/features/atoms/glove/japan/constants/baseModel'
import { outfielderReducer } from 'src/features/atoms/glove/japan/slice/outfielder'
import { BaseModelSelector } from 'src/Components/Domain/BaseModelSelector'
import { OrderPageTemplate } from 'src/Components/Domain/OrderPageTemplate'
import { useLocale } from 'src/locales/useLocale'

const AtomsOutfield: React.FC = () => {
  const { t } = useLocale()
  const router = useRouter()
  const models = atomsBaseModel(t, router)
  const [state, dispatch] = React.useReducer(outfielderReducer, t.INITIAL_STATE_OUTFIELDER)
  const { figurePanelNum } = state
  const handleFigurePanelNum = (_, newValue: 0 | 1) => dispatch({ ...state, type: SET_FIGURE_PANEL_NUMBER, figurePanelNum: newValue })
  return (
    <OrderPageTemplate
      breadcrumbTrail={`${t.HARD} / ATOMS / ${t.OUTFIELDER}`}
      brand={'atoms'}
      {...{ figurePanelNum, state, dispatch, handleFigurePanelNum }}
    >
      <BaseModelSelector {...{ state, models, dispatch }} />
      <Setters {...{ state, figurePanelNum, dispatch }} />
    </OrderPageTemplate>
  )
}

export default AtomsOutfield
